"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultWebhookGameCenterEventList = void 0;
const webhook_1 = require("../../enums/webhook");
exports.defaultWebhookGameCenterEventList = [
    {
        type: webhook_1.WebhookGameCenterEventType.GAME_CENTER_SIGN_UP,
        description: 'Game Center Sign Up',
        isEnabled: true,
    },
    {
        type: webhook_1.WebhookGameCenterEventType.GAME_CENTER_ADDITIONAL_FORM_SUBMISSION,
        description: 'Game Center Additional Form Submission',
        isEnabled: true,
    },
];
